/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var log = require('../../utils/logger')('splitio-engine:matcher');
var difference = require('lodash/difference');

function equalToSetMatcherContext(ruleAttr /*: array */) /*: Function */{
  return function equalToSetMatcher(runtimeAttr /*: array */) /*: boolean */{
    var isEqual = runtimeAttr.length === ruleAttr.length && difference(ruleAttr, runtimeAttr).length === 0;

    log.debug('[equalToSetMatcher] is ' + runtimeAttr + ' equal to set ' + ruleAttr + '? ' + isEqual);

    return isEqual;
  };
}

module.exports = equalToSetMatcherContext;


//////////////////
// WEBPACK FOOTER
// ./~/@splitsoftware/splitio/lib/engine/matchers/eq_set.js
// module id = 632
// module chunks = 7